module.exports = __webpack_public_path__ + "img/map-sm.35592531.jpg";